import React, { useState, useEffect, useCallback } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import _isNil from "lodash/isNil";

import ProjectDateColumnForm from "./ProjectDateColumnForm";
import { closeModalDialog } from "../../../../../actions/layoutActions";
import propTypes from "../../../../../constants/propTypes";
import {
  performUpdateRequest,
  setReload,
} from "../../../../../actions/dataComponentActions";

import { updateProject } from "../../../../../actions/projectsActions";

import { LoaderContext } from "../../../../ui/Loader";
import { getDataComponent } from "../../../../../reducers/dataComponentReducer";
import { handleRequestError } from "../../../../../utils/formValidationUtils";
import { processUpdateRequestStatus } from "../../../../../utils/dataComponentUtils";
import { dataComponentId } from "../ProjectsContainer";

export const processRequestResponse = (
  prevDataComponent,
  dataComponent,
  closeModalDialog,
  setReload,
  formikActions
) => {
  processUpdateRequestStatus(prevDataComponent, dataComponent, {
    onSuccess: () => {
      closeModalDialog();
      setReload(dataComponentId, true);
    },
    onError: error => handleRequestError(error, formikActions),
  });
};

export const EditProjectDateColumnContainer = ({
  dataComponent,
  closeModalDialog,
  project,
  column,
  setReload,
  updateProject,
  loading,
}) => {
  const [prevDataComponent, setPrevDataComponent] = useState(dataComponent);
  const [formikActions, setFormikAction] = useState(null);

  useEffect(() => {
    setPrevDataComponent(dataComponent);
  }, [dataComponent]);

  useEffect(() => {
    processRequestResponse(
      prevDataComponent,
      dataComponent,
      closeModalDialog,
      setReload,
      formikActions
    );
  }, [
    closeModalDialog,
    dataComponent,
    formikActions,
    prevDataComponent,
    setReload,
  ]);

  const handleEditProject = useCallback(
    (project, formikActions) => {
      if (_isNil(project[column])) {
        formikActions.setErrors({
          [column]: "This field can't be empty",
        });
        return;
      }
      updateProject(
        project.id,
        {
          ...project,
        },
        dataComponentId
      );
      setFormikAction(formikActions);
    },
    [column, updateProject]
  );

  const initialValues = {
    id: project.id,
    [column]: project[column],
  };

  return (
    <LoaderContext.Provider value={{ loading }}>
      <ProjectDateColumnForm
        initialValues={initialValues}
        onSubmit={handleEditProject}
        column={column}
        dataComponentId={dataComponent.dataComponentId}
      />
    </LoaderContext.Provider>
  );
};

EditProjectDateColumnContainer.propTypes = {
  dataComponent: propTypes.dataComponent,
  closeModalDialog: PropTypes.func,
  project: propTypes.project,
  column: PropTypes.string.isRequired,
  performUpdateRequest: PropTypes.func,
  loading: PropTypes.bool,
  setReload: PropTypes.func,
  updateProject: PropTypes.func,
};

export const mapDispatchToProps = {
  closeModalDialog,
  performUpdateRequest,
  updateProject,
  setReload,
};

const mapStateToProps = state => {
  const dataComponent = getDataComponent(dataComponentId, state);
  return {
    dataComponent,
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(EditProjectDateColumnContainer);
